import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig, buildMsalConfig, fetchAuthConfig } from "./msal/authConfig";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/index.css";

import App from "./App.jsx";

async function bootstrap() {
   const authConfig = await fetchAuthConfig();
   const msalConfig = buildMsalConfig(authConfig);
   const msalInstance = new PublicClientApplication(msalConfig);

   await msalInstance.initialize();

   // Default to using the first account if no account is active on page load
   if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      const allAccounts = msalInstance.getAllAccounts();
      console.log("Allaccounts: ", allAccounts);
      msalInstance.setActiveAccount(allAccounts[0]); // Bugfix: kein "()" hinter allAccounts
   }

   // Listen for sign-in event and set active account
   msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
         const account = event.payload.account;
         msalInstance.setActiveAccount(account);
      }
   });

   createRoot(document.getElementById("root")).render(<App msalInstance={msalInstance} />);
}

bootstrap().catch((err) => {
   console.error("Fehler beim Initialisieren der App:", err);
   // Optional: Fehler-UI rendern, z.B. "Verbindung zum Server fehlgeschlagen"
   createRoot(document.getElementById("root")).render(
      <div style={{ padding: 20 }}>Fehler beim Laden der Anwendung. Bitte später erneut versuchen.</div>,
   );
});
